import {
    FETCH_ORGANIZATION_ROLES_REQUEST,
    FETCH_ORGANIZATION_ROLES_SUCCESS,
    FETCH_ORGANIZATION_ROLES_FAILURE,
    UPDATE_STAFF_SEARCH,
    ASSIGN_ROLE_REQUEST,
    ASSIGN_ROLE_SUCCESS,
    ASSIGN_ROLE_FAILURE,
    REMOVE_ROLE_REQUEST,
    REMOVE_ROLE_SUCCESS,
    REMOVE_ROLE_FAILURE,
    INVITE_STAFF_REQUEST,
    INVITE_STAFF_SUCCESS,
    INVITE_STAFF_FAILURE,
    FETCH_PENDING_INVITES_REQUEST,
    FETCH_PENDING_INVITES_SUCCESS,
    FETCH_PENDING_INVITES_FAILURE,
    CANCEL_INVITE_SUCCESS,
    UPLOAD_STAFF_PHOTO_REQUEST,
    UPLOAD_STAFF_PHOTO_SUCCESS,
    UPLOAD_STAFF_PHOTO_FAILURE,
    CLEAR_STAFF_ERROR,
} from 'features/settings/staff/actions';

import {
    ATTEMPT_UPLOAD_ORGANIZATION_LOGO,
    UPLOAD_ORGANIZATION_LOGO_SUCCEEDED,
    UPLOAD_ORGANIZATION_LOGO_FAILED,
} from 'shared_redux/actions';

const initialState = {
    loading: false,
    staffMembers: [],
    pendingInvites: [],
    searchTerm: '',
    error: null,
    isUploadingLogo: false,
    isUploadingPhoto: false,
};

export default function staffReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_ORGANIZATION_ROLES_REQUEST:
        case ASSIGN_ROLE_REQUEST:
        case REMOVE_ROLE_REQUEST:
        case INVITE_STAFF_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_ORGANIZATION_ROLES_SUCCESS: {
            // Find the current user's avatar from the staff members
            const currentUserMember = (action.payload.staffMembers || []).find(member => member?.account?.isCurrentUser);
            return {
                ...state,
                loading: false,
                staffMembers: action.payload.staffMembers || [],
                error: null,
                currentUserAvatar: currentUserMember?.avatar ?? state.currentUserAvatar,
            };
        }

        case ASSIGN_ROLE_SUCCESS:
            return {
                ...state,
                loading: false,
                staffMembers: state.staffMembers.map(member =>
                    member.account_id === action.payload.accountId
                        ? {
                            ...member,
                            role: action.payload.role,
                            title: action.payload.title,
                            bio: action.payload.bio,
                            photo: action.payload.photo,
                            name: action.payload.name,
                            last_name: action.payload.last_name,
                            instagram: action.payload.instagram,
                            tiktok: action.payload.tiktok,
                            facebook: action.payload.facebook,
                            twitter: action.payload.twitter,
                        }
                        : member
                ),
                error: null,
            };

        case REMOVE_ROLE_SUCCESS:
            return {
                ...state,
                loading: false,
                staffMembers: state.staffMembers.filter(
                    member => member.account_id !== action.payload.accountId
                ),
                error: null,
            };

        case FETCH_ORGANIZATION_ROLES_FAILURE:
        case ASSIGN_ROLE_FAILURE:
        case REMOVE_ROLE_FAILURE:
        case INVITE_STAFF_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };

        case UPDATE_STAFF_SEARCH:
            return {
                ...state,
                searchTerm: action.payload.searchTerm,
            };

        case FETCH_PENDING_INVITES_SUCCESS:
            return {
                ...state,
                pendingInvites: action.payload.invites || [],
            };

        case INVITE_STAFF_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingInvites: [...state.pendingInvites, action.payload.invite],
                error: null,
            };

        case CANCEL_INVITE_SUCCESS:
            return {
                ...state,
                pendingInvites: state.pendingInvites.filter(
                    invite => invite.id !== action.payload.inviteId
                ),
            };

        case ATTEMPT_UPLOAD_ORGANIZATION_LOGO:
            return {
                ...state,
                isUploadingLogo: true,
                error: null,
            };

        case UPLOAD_ORGANIZATION_LOGO_SUCCEEDED:
            return {
                ...state,
                isUploadingLogo: false,
                error: null,
            };

        case UPLOAD_ORGANIZATION_LOGO_FAILED:
            return {
                ...state,
                isUploadingLogo: false,
                error: action.payload,
            };

        case UPLOAD_STAFF_PHOTO_REQUEST:
            return {
                ...state,
                isUploadingPhoto: true,
                error: null,
            };

        case UPLOAD_STAFF_PHOTO_SUCCESS:
            return {
                ...state,
                isUploadingPhoto: false,
                staffMembers: state.staffMembers.map(member =>
                    member.account_id === action.payload.accountId
                        ? { ...member, photo: action.payload.photo }
                        : member
                ),
                error: null,
            };

        case UPLOAD_STAFF_PHOTO_FAILURE:
            return {
                ...state,
                isUploadingPhoto: false,
                error: action.payload.error,
            };

        case CLEAR_STAFF_ERROR:
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
}